const CONTEXT_SWITCH_INTENT_KEY = 'communo_context_switch_intent_until'
const CONTEXT_SWITCH_INTENT_WINDOW_MS = 12000

/**
 * While a context switch is in progress, {@link isContextSwitchIntentActive} is true so
 * `RequireAuth` can redirect instead of blocking on the personal/network context dialogs.
 *
 * For **new** navigations to `/n/...` while still in user context (e.g. after creating a network),
 * call `switchContext(networkIri, name)` **before** `navigate()` so the JWT/context matches the
 * route and the network dialog is not shown.
 */
export const markContextSwitchIntent = () => {
  if (typeof window === 'undefined') {
    return
  }
  const until = Date.now() + CONTEXT_SWITCH_INTENT_WINDOW_MS
  localStorage.setItem(CONTEXT_SWITCH_INTENT_KEY, String(until))
}

export const isContextSwitchIntentActive = (): boolean => {
  if (typeof window === 'undefined') {
    return false
  }
  const raw = localStorage.getItem(CONTEXT_SWITCH_INTENT_KEY)
  if (!raw) {
    return false
  }
  const until = Number(raw)
  if (!Number.isFinite(until)) {
    return false
  }
  return Date.now() <= until
}
